import { splunkInstance } from '@/common/services/splunk';
import { getCookie } from 'cookies-next';

export const sendBookEvent = ({ bookInfo, userInfo, doctorInfo }: { bookInfo: any; userInfo: any; doctorInfo: any }) => {
  splunkInstance('booking').sendEvent({
    group: 'doctor profile',
    type: 'doctor profile book received',
    event: {
      data: {
        ...doctorInfo,
        user_id: userInfo.id,
        reference_code: bookInfo.reference_code,
        date: bookInfo.from,
        user_agent: window.navigator.userAgent,
        terminal_id: getCookie('terminal_id'),
        center_id: bookInfo.center_id,
      },
    },
  });
};
